import { IFormSection, TSubmitType } from "../../types/common";
import {
  API_OTHER_INCOME,
  API_PAYMENT_MODES_CONFIGURABLES,
} from "../../utils/apis";

import { URL_OTHER_INCOME } from "../../utils/urls";
import {
  BOOLEAN_SELECTIONS,
  FORM_DATA,
  INCOME_TYPE,
} from "../../utils/constants";
import { useGetConfigurableOptions } from "../../utils/formUtils";
import { getAndPrepareFiles, getResultOptions } from "../../utils/helpers";
import { useEffect } from "react";
import useGet from "../common/useGet";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useOtherIncomeForm = ({ form }) => {
  const sections: IFormSection[] = [
    {
      title: "Income Details",
      fields: [
        {
          field_name: "income_type",
          type: "select",
          label: "Income Type",
          props: { required: true },
          options_name: "income_types",
        },
        {
          field_name: "income_amount",
          type: "number",
          label: "Income Amount",
          props: { required: true },
        },
        {
          field_name: "income_date",
          type: "date",
          label: "Income Date",
          props: { required: true },
        },
        {
          field_name: "is_recurring",
          type: "select",
          label: "Is Recurring",
          props: { required: true },
          options_data: BOOLEAN_SELECTIONS,
        },
        {
          field_name: "recurring_income_frequency",
          type: "select",
          label: "Recurring Frequency",
          props: { required: true },
          options_data: [
            { id: "daily", name: "Daily" },
            { id: "weekly", name: "Weekly" },
            { id: "monthly", name: "Monthly" },
            { id: "quarterly", name: "Quarterly" },
            { id: "annually", name: "Annually" },
          ],
          visible: form?.is_recurring == true,
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
        },
        {
          field_name: "accounting",
          type: "select",
          label: "Accounting",
          props: { required: true },
          options_data: [
            { id: "cash", name: "Cash" },
            { id: "bank", name: "Bank" },
          ],
        },
        {
          field_name: "payment_method",
          type: "select",
          label: "Payment Method",
          props: { required: true },
          options_name: "payment_modes",
        },
      ],
    },
    {
      title: "Income Source Details",
      fields: [
        {
          field_name: "first_name",
          type: "text",
          label: "First Name",
          props: { required: true },
        },
        {
          field_name: "last_name",
          type: "text",
          label: "Last Name",
          props: { required: true },
        },
        {
          field_name: "other_name",
          type: "text",
          label: "Other Name",
        },
        {
          field_name: "phone_number",
          type: "tel",
          label: "Payee Phone Number",
        },
        {
          field_name: "email",
          type: "email",
          label: "Payee Email",
        },
        {
          field_name: "organization_name",
          type: "text",
          label: "Organization Name",
          props: { required: true },
        },
      ],
    },
    {
      title: "Supporting Documents",
      fields: [
        {
          field_name: "other_income_invoice",
          type: "file",
          label: "Invoice / Receipt",
        },
      ],
    },
  ];

  const redirect = `${URL_OTHER_INCOME}`;

  const getConfigOptions = () => {
    const configList = [{ name: "income_types", key: INCOME_TYPE }];
    const { loadData: getPaymentModes, data: paymentModes } = useGet();
    useEffect(() => {
      getPaymentModes({
        api: API_PAYMENT_MODES_CONFIGURABLES,
        params: { active: true },
      });
    }, []);
    return {
      ...useGetConfigurableOptions(configList),
      payment_modes: getResultOptions(paymentModes, "mode", "mode"),
    };
  };
  const options = {
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitOtherIncome(payload: any, id: number | null) {
  let preppedPayload = getAndPrepareFiles(payload, ["other_income_invoice"]);
  return {
    api: API_OTHER_INCOME,
    id,
    type: FORM_DATA,
    params: preppedPayload,
  };
}
